import React, {Component, Fragment} from 'react';
import {Route, Routes} from 'react-router-dom'
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {withTranslation} from "react-i18next";
import NewsList from "./NewsList";
import NewsDetailController from "./NewsDetailController";
import {GelContentContainer, NotFound, Sanitize, PageTracking} from 'cw-styleguide-react';
import config from '../../config';

class News extends Component {
    render() {
        return (
            <Fragment>
                <PageTracking />
                <BreadcrumbsItem to={'/'}>
                    {this.props.t('local:route_news_title')}
                </BreadcrumbsItem>
                <Routes>
                    <Route exact path={'/'} element={<NewsList/>}/>
                    <Route path={'/:alias'} element={<NewsDetailController/>}/>
                    <Route path="*" element={<GelContentContainer><NotFound domain={config.domain}/></GelContentContainer>}/>
                </Routes>
            </Fragment>
        )
    }
}

export default withTranslation('common')(News)